export default __webpack_public_path__ + "static/media/climatechangeai_Tackling_Climate_Change_with_Machine_Learning.1f264629.pdf";